import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
  JobseekerModerationAttributeEnum,
  RejectModel,
} from '../../shared/models/jobseeker-moderation.model';

@Component({
  selector: 'app-jobseeker-contact-info',
  templateUrl: './jobseeker-contact-info.component.html',
  styleUrls: ['./jobseeker-contact-info.component.less'],
  standalone: false,
})
export class JobseekerContactInfoComponent {
  public jobseekerEnum: any;
  @Input() jobseeker!: any;
  @Input() jobseekerModerationId!: string;
  @Input() changes!: any;
  @Input() isCreate!: boolean;
  @Input() isEdited!: boolean;
  @Output() rejectFields: EventEmitter<RejectModel> =
    new EventEmitter<RejectModel>();

  constructor() {
    this.jobseekerEnum = JobseekerModerationAttributeEnum;
  }

  reject(event) {
    this.rejectFields.emit({ key: event.key, value: event.value });
  }
}
